import { RouteConfig } from 'vue-router'

export const Index = () => import('../activity/sports-game/sv-2025/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/sports-game/sv-2025',
  name: 'activity_sports_game_sv_2025',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '暑期开卡礼多多',
  },
}

export default [indexRoute]
